const FORBIDDEN_CODE_CHARS: number[] = [
	8207, // https://www.fileformat.info/info/unicode/char/200f/index.htm
];

interface Options {
	// When this is true, only `a-z`, `A-Z`, `0-9`, `-` and `_` is allowed.
	shouldHaveSafeCharsOnly?: boolean;
	// When this is true, 'encodeURIComponent' is used to encode the input string
	shouldEncode?: boolean;
}

export function sanitiseValue(value: string, options: Options = {}): string {
	let trimmedStr = value.trim();

	FORBIDDEN_CODE_CHARS.forEach((codeChar) => {
		const char = String.fromCharCode(codeChar);
		const re = new RegExp(char, 'gm');
		trimmedStr = trimmedStr.replace(re, '');
	});

	if (options.shouldHaveSafeCharsOnly) {
		trimmedStr = trimmedStr.replace(/[^a-z0-9_-]/gim, '');
		trimmedStr = trimmedStr.trim();
	}

	if (options.shouldEncode) {
		trimmedStr = encodeURIComponent(trimmedStr);
	}

	return trimmedStr;
}
